module.exports = __webpack_public_path__ + "img/ev.8185b737.png";